import $ from "jquery";
import * as moment from "moment";
import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import { AbsenceSalarieDto } from "../../../dto/GenApi.iNotPaie.Dto/AbsenceSalarieDto";
import { AttestationCrpcenDto } from "../../../dto/GenApi.iNotPaie.Dto/AttestationCrpcenDto";
import { CommuneDto } from "../../../dto/GenApi.iNotPaie.Dto/CommuneDto";
import { ParametresInstance } from "../../Controls/Parameters";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";

@Component
export default class ModalGenerationCRPCEN extends Vue {
	public avecSubrogation = false;
	public dateEntreeSalarie = "";
	public dateDernierJourTravail = "";
	public dateRepriseTravail = "";
	public dateDebutSubrogation = "";
	public dateDebutSubrogationMasquee = "";
	public dateFinSubrogation = "";
	public dateFinSubrogationMasquee = "";
	public codeMoisMoins1 = 0;
	public codeMoisMoins2 = 0;
	public codeMoisMoins3 = 0;
	public attestationCrpcenDto: AttestationCrpcenDto = {
		NumeroSalarie: 0,
		MontantBrutMoisMoins1: 0,
		MontantBrutMoisMoins2: 0,
		MontantBrutMoisMoins3: 0,
		MontantTreiziemeMois: 0,
		MontantGratifications: 0,
		NombreHeuresMensuelles: 0,
		EstDelaiCarenceNonSubroge: false,
		EstRepriseTempsPartielMotifMedical: false
	};

	public listeMois = ParametresInstance.listeMoisKeyValue;
	public listeCommunes: CommuneDto[] = [];

	@Watch("attestationCrpcenDto.CodePostalSalarie")
	public onCodePostalCherchePropertyChanged(): void {
		if (this.attestationCrpcenDto.CodePostalSalarie) {
			const codePostal = this.attestationCrpcenDto.CodePostalSalarie;
			this.listeCommunes = ParametresInstance.allCommune.filter(c => c.LibelleCodePostale != undefined && c.LibelleCodePostale.toLowerCase().indexOf(codePostal.toLowerCase()) >= 0).slice(0, 24);
		}
	}

	@Watch("attestationCrpcenDto.CommuneSalarie")
	public onCommuneCherchePropertyChanged(): void {
		if (this.attestationCrpcenDto.CommuneSalarie) {
			const commune = this.attestationCrpcenDto.CommuneSalarie;
			this.listeCommunes = ParametresInstance.allCommune.filter(c => c.LibelleCodePostale != undefined && c.LibelleCodePostale.toLowerCase().indexOf(commune.toLowerCase()) >= 0).slice(0, 24);
		}
	}

	public init(absenceSalarie: AbsenceSalarieDto): void {
		ServicesFactoryInstance.AbsencesService.getAttestationCrpcen(absenceSalarie.Id ?? 0, attestationCrpcenDto => {
			this.attestationCrpcenDto = attestationCrpcenDto;
			// Initialisation des variables externalisées.
			this.avecSubrogation = !!attestationCrpcenDto.DateDebutSubrogation;
			this.codeMoisMoins1 = this.listeMois.filter(m => m.value === attestationCrpcenDto.LibelleMoisMoins1)[0]?.key ?? 0;
			this.codeMoisMoins2 = this.listeMois.filter(m => m.value === attestationCrpcenDto.LibelleMoisMoins2)[0]?.key ?? 0;
			this.codeMoisMoins3 = this.listeMois.filter(m => m.value === attestationCrpcenDto.LibelleMoisMoins3)[0]?.key ?? 0;
			this.dateEntreeSalarie = this.GetStringFromDate(attestationCrpcenDto.DateEntreeSalarie);
			this.dateDernierJourTravail = this.GetStringFromDate(attestationCrpcenDto.DateDernierJourTravail);
			this.dateRepriseTravail = this.GetStringFromDate(attestationCrpcenDto.DateRepriseTravail);
			this.dateDebutSubrogation = this.GetStringFromDate(attestationCrpcenDto.DateDebutSubrogation);
			this.dateFinSubrogation = this.GetStringFromDate(attestationCrpcenDto.DateFinSubrogation);
			this.modifiyNumeroSecuriteSociale();

			this.$forceUpdate();
		});
	}

	public GetStringFromDate(date?: Date): string {
		if (!date) {
			return "";
		}

		return moment(date).format("YYYY-MM-DD");
	}

	public GetDateFromString(dateString: string): Date | undefined {
		const timestampUTC: number = Date.parse(dateString);
		const date: Date = new Date(timestampUTC);

		return date;
	}

	public modifierCommune(libelleRecherche: string): void {
		let commune: CommuneDto | undefined;
		for (let i = 0; i < this.listeCommunes.length; i++) {
			if (this.listeCommunes[i].LibelleCodePostale == libelleRecherche ||
				this.listeCommunes[i].CodePostal == libelleRecherche ||
				this.listeCommunes[i].Libelle == libelleRecherche) {
				commune = this.listeCommunes[i];
				break;
			}
		}

		if (commune != undefined) {
			this.attestationCrpcenDto.CodePostalSalarie = commune.CodePostal;
			this.attestationCrpcenDto.CommuneSalarie = commune.Libelle;
		}
		this.$forceUpdate();
	}

	public modifiyNumeroSecuriteSociale(): void {
		const numeroSecuriteSociale = this.attestationCrpcenDto?.NumeroSecuriteSocialeSalarie;
		if (numeroSecuriteSociale) {
			this.setNumeroSecuriteSociale(numeroSecuriteSociale.replace(/ /gi, ""));
		}
	}

	public setNumeroSecuriteSociale(numeroSecuriteSociale: string): void {
		let numeroSecuriteSocialeFormate = "";
		for (let i = 0; i < numeroSecuriteSociale.length; i++) {
			numeroSecuriteSocialeFormate += numeroSecuriteSociale[i];
			if ((i == 0 || i == 2 || i == 4 || i == 6 || i == 9 || i == 12) && i < numeroSecuriteSociale.length - 1) {
				numeroSecuriteSocialeFormate += " ";
			}
		}
		this.attestationCrpcenDto.NumeroSecuriteSocialeSalarie = numeroSecuriteSocialeFormate;
	}

	public cancel(): void {
		$("#modalGenerationCRPCEN").modal("hide");
	}

	public downloadPdf(): void {
		// Réaffectation des paramètres externalisées
		this.attestationCrpcenDto.DateDernierJourTravail = this.GetDateFromString(this.dateDernierJourTravail);
		this.attestationCrpcenDto.DateRepriseTravail = this.GetDateFromString(this.dateRepriseTravail);
		this.attestationCrpcenDto.DateDebutSubrogation = this.avecSubrogation ? this.GetDateFromString(this.dateDebutSubrogation) : undefined;
		this.attestationCrpcenDto.DateFinSubrogation = this.avecSubrogation ? this.GetDateFromString(this.dateFinSubrogation) : undefined;
		this.attestationCrpcenDto.EstDelaiCarenceNonSubroge = this.avecSubrogation ? this.attestationCrpcenDto.EstDelaiCarenceNonSubroge : false;
		this.attestationCrpcenDto.LibelleMoisMoins1 = this.listeMois.filter(m => m.key === this.codeMoisMoins1)[0]?.value ?? "";
		this.attestationCrpcenDto.LibelleMoisMoins2 = this.listeMois.filter(m => m.key === this.codeMoisMoins2)[0]?.value ?? "";
		this.attestationCrpcenDto.LibelleMoisMoins3 = this.listeMois.filter(m => m.key === this.codeMoisMoins3)[0]?.value ?? "";

		ServicesFactoryInstance.AbsencesService.generationAttestationCrpcen(this.attestationCrpcenDto, data => {
			this.download(data);
			this.$forceUpdate();
		});
		this.cancel();
	}

	public download(r: Blob): void {
		const link = document.createElement("a");
		document.body.appendChild(link);

		link.href = window.URL.createObjectURL(r);
		link.download = "Attestation IJ CRPCEN";
		link.click();
	}

	public toggleAvecSubrogation(): void {
		this.avecSubrogation = !this.avecSubrogation;

		if (this.avecSubrogation) {
			this.dateDebutSubrogation = this.dateDebutSubrogationMasquee;
			this.dateFinSubrogation = this.dateFinSubrogationMasquee;
		} else {
			this.dateDebutSubrogationMasquee = this.dateDebutSubrogation;
			this.dateDebutSubrogation = "";
			this.dateFinSubrogationMasquee = this.dateFinSubrogation;
			this.dateFinSubrogation = "";
		}
	}

	public toggleDelaiCarenceNonSubroge(): void {
		this.attestationCrpcenDto.EstDelaiCarenceNonSubroge = !this.attestationCrpcenDto.EstDelaiCarenceNonSubroge;
	}

	public onDateRepriseTravailChange(): void {
		if (!this.dateRepriseTravail) {
			this.attestationCrpcenDto.EstRepriseTempsPartielMotifMedical = false;
		}
	}

	public toggleRepriseTempsPartielMotifMedical(): void {
		this.attestationCrpcenDto.EstRepriseTempsPartielMotifMedical = !this.attestationCrpcenDto.EstRepriseTempsPartielMotifMedical;
	}
}



// WEBPACK FOOTER //
// ./src/components/planningAbsences/modalGenerationCRPCEN/modalGenerationCRPCEN.ts